const MoonMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="30" stroke="currentColor" strokeOpacity="0.35" strokeWidth="1.5" />
    <path d="M41 10a24 24 0 1 0 0 44 26.5 26.5 0 0 1 0-44Z" fill="currentColor" />
    <path
      d="M48 22l1.9 4.8 4.9 1.4-4.9 1.5L48 34.6l-1.9-4.9-4.9-1.5 4.9-1.4L48 22Z"
      fill="currentColor"
      fillOpacity="0.9"
    />
  </svg>
);

export default MoonMark;
